import { Theme } from './types';

export const halloweenTheme: Theme = {
  id: 'halloween',
  name: 'Halloween Spooky',
  description: 'Spooky Halloween experience with dark, eerie colors and haunting animations',

  colors: {
    choice1: 'linear-gradient(135deg, #ff6b35 0%, #f77f00 100%)', // Pumpkin Orange
    choice2: 'linear-gradient(135deg, #6A0572 0%, #9d4edd 100%)', // Deep Purple
    choice3: 'linear-gradient(135deg, #0d1b2a 0%, #415a77 100%)', // Dark Blue-Gray
    choice4: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', // Toxic Green

    correct: '#10b981',
    incorrect: '#dc2626',

    background: 'transparent',
    cardBackground: 'rgba(13, 27, 42, 0.85)',
    textPrimary: '#ff6b35',
    textSecondary: '#f8f9fa',
    accent: '#f77f00',

    timerHigh: '#10b981',
    timerMid: '#ff6b35',
    timerLow: '#dc2626',

    // Semantic colors
    surface: 'rgba(13, 27, 42, 0.85)',
    surfaceVariant: 'rgba(26, 42, 62, 0.9)',
    onSurface: '#f8f9fa',
    onSurfaceVariant: '#ff6b35',
    outline: 'rgba(247, 127, 0, 0.4)',
    outlineVariant: 'rgba(247, 127, 0, 0.2)',
    scrim: 'rgba(0, 0, 0, 0.7)',

    // Interactive element colors
    primary: 'linear-gradient(135deg, #ff6b35 0%, #f77f00 100%)',
    onPrimary: '#ffffff',
    secondary: 'linear-gradient(135deg, #6A0572 0%, #9d4edd 100%)',
    onSecondary: '#ffffff',

    // Status colors
    success: '#10b981',
    warning: '#ff6b35',
    error: '#dc2626',
    info: '#6A0572',
  },

  typography: {
    fontFamily: "'Creepster', 'Nosifer', 'Poppins', system-ui, sans-serif",
    questionSize: '2xl',
    answerSize: 'base',
    scoreSize: 'sm',

    sizes: {
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
    },

    lineHeights: {
      tight: 'leading-tight',
      normal: 'leading-normal',
      relaxed: 'leading-relaxed',
    },

    weights: {
      normal: 'font-normal',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
  },

  animations: {
    buttonHover: 'hover:scale-105 hover:-rotate-2 transition-all duration-300',
    buttonPress: 'scale-110 rotate-2 ring-4 ring-orange-500',
    correctAnswer: 'animate-pulse',
    wrongAnswer: 'shake-crazy',
    transition: 'transition-all duration-300',
  },

  emojis: {
    choice1: '🎃',
    choice2: '👻',
    choice3: '🦇',
    choice4: '💀',
    score: '🕷️',
    timer: '⏱️',
    correct: '✅',
    incorrect: '❌',
  },

  audio: {
    enabled: true,
  },

  effects: {
    particles: true,
    glassmorphism: false,
    buttonShadows: true,
    confetti: true,
    screenShake: true,
  },

  layout: {
    buttonShape: 'rounded',
    buttonArrangement: 'grid',
    spacing: 'normal',
  },

  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    '2xl': '4rem',
  },

  elevation: {
    none: 'shadow-none',
    sm: 'shadow-md',
    md: 'shadow-lg',
    lg: 'shadow-xl',
    xl: 'shadow-2xl',
  },

  borderRadius: {
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    full: '9999px',
  },

  customCSS: `
    /* Halloween theme custom styles */
    .theme-halloween {
      background: linear-gradient(135deg, #0d1b2a 0%, #1a1a2e 50%, #16213e 100%);
    }

    .theme-halloween .text-shadow {
      text-shadow: 0 0 10px rgba(255, 107, 53, 0.8),
                   0 0 20px rgba(247, 127, 0, 0.6);
    }

    .theme-halloween button {
      box-shadow: 0 4px 15px rgba(255, 107, 53, 0.4);
      border: 2px solid rgba(247, 127, 0, 0.3);
    }

    .theme-halloween button:hover {
      box-shadow: 0 6px 25px rgba(255, 107, 53, 0.6);
      border-color: rgba(247, 127, 0, 0.6);
    }

    /* Spooky glow effect */
    .theme-halloween .glow {
      animation: spooky-glow 2s ease-in-out infinite;
    }

    @keyframes spooky-glow {
      0%, 100% {
        filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.5));
      }
      50% {
        filter: drop-shadow(0 0 20px rgba(247, 127, 0, 0.8));
      }
    }

    /* Floating animation for emojis */
    .theme-halloween .emoji {
      animation: float-spooky 3s ease-in-out infinite;
    }

    @keyframes float-spooky {
      0%, 100% {
        transform: translateY(0px) rotate(0deg);
      }
      50% {
        transform: translateY(-10px) rotate(5deg);
      }
    }
  `,
};